export const reportPageWrapperSx = {
  p: { xs: 1, md: 2 },
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  width: "100%",
};

export const reportShellSx = {
  flex: 1,
  borderRadius: "10px",
  border: "1px solid",
  borderColor: "divider",
  borderTop: "3px solid",
  borderTopColor: "primary.main",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
};

export const reportContentSx = {
  px: { xs: 1, md: 2 },
  py: { xs: 1, md: 1.5 },
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
};

export const reportFilterCardSx = {
  p: { xs: 1.25, md: 1.5 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "background.paper",
  "& .MuiTextField-root": {
    borderRadius: 1.5,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    backgroundColor: "var(--ec-input-bg)",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "var(--ec-input-bg)",
  },
  "& .MuiInputBase-input": {
    backgroundColor: "transparent",
  },
  "& .MuiNativeSelect-select": {
    backgroundColor: "transparent",
  },
  "& .MuiSelect-select": {
    backgroundColor: "transparent",
  },
  "& .MuiAutocomplete-inputRoot": {
    backgroundColor: "var(--ec-input-bg)",
  },
  "& .Mui-disabled": {
    WebkitTextFillColor: "inherit",
  },
};

const reportFilterFieldSurfaceSx = {
  "& .MuiTextField-root": {
    borderRadius: 1.5,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    backgroundColor: "var(--ec-input-bg)",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "var(--ec-input-bg)",
  },
  "& .MuiInputBase-input": {
    backgroundColor: "transparent",
  },
  "& .MuiNativeSelect-select": {
    backgroundColor: "transparent",
  },
  "& .MuiSelect-select": {
    backgroundColor: "transparent",
  },
  "& .MuiAutocomplete-inputRoot": {
    backgroundColor: "var(--ec-input-bg)",
  },
  "& .Mui-disabled": {
    WebkitTextFillColor: "inherit",
  },
};

export const reportFilterCardContentSx = reportFilterFieldSurfaceSx;

export const reportFilterGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(180px, 1fr))",
    lg: "repeat(4, minmax(180px, 1fr))",
  },
  gap: 1.5,
  ...reportFilterFieldSurfaceSx,
};

export const REPORT_SUMMARY_TONES = {
  default: {
    accent: "var(--ec-color-border-strong, #cbd5e1)",
    border: "rgba(148, 163, 184, 0.3)",
    background: "rgba(248, 250, 252, 0.9)",
    valueColor: "text.primary",
  },
  sales: {
    accent: "var(--ec-status-info-border, #3b82f6)",
    border: "rgba(59, 130, 246, 0.26)",
    background: "rgba(239, 246, 255, 0.96)",
    valueColor: "var(--ec-status-info-text, #1d4ed8)",
  },
  revenue: {
    accent: "var(--ec-status-info-border, #2563eb)",
    border: "rgba(37, 99, 235, 0.26)",
    background: "rgba(239, 246, 255, 0.96)",
    valueColor: "var(--ec-status-info-text, #1d4ed8)",
  },
  margin: {
    accent: "var(--ec-status-success-border, #22c55e)",
    border: "rgba(34, 197, 94, 0.28)",
    background: "rgba(240, 253, 244, 0.96)",
    valueColor: "var(--ec-status-success-text, #15803d)",
  },
  profit: {
    accent: "var(--ec-status-success-border, #16a34a)",
    border: "rgba(22, 163, 74, 0.28)",
    background: "rgba(240, 253, 244, 0.96)",
    valueColor: "var(--ec-status-success-text, #166534)",
  },
  percentage: {
    accent: "var(--ec-status-accent-border, #6366f1)",
    border: "rgba(99, 102, 241, 0.26)",
    background: "rgba(238, 242, 255, 0.96)",
    valueColor: "var(--ec-status-accent-text, #4338ca)",
  },
  budget: {
    accent: "var(--ec-status-accent-border, #7c3aed)",
    border: "rgba(124, 58, 237, 0.24)",
    background: "rgba(245, 243, 255, 0.98)",
    valueColor: "var(--ec-status-accent-text, #5b21b6)",
  },
  count: {
    accent: "var(--ec-color-border-strong, #64748b)",
    border: "rgba(100, 116, 139, 0.24)",
    background: "rgba(248, 250, 252, 0.98)",
    valueColor: "text.primary",
  },
  warning: {
    accent: "var(--ec-status-warning-border, #f59e0b)",
    border: "rgba(245, 158, 11, 0.28)",
    background: "rgba(255, 251, 235, 0.98)",
    valueColor: "var(--ec-status-warning-text, #b45309)",
  },
  danger: {
    accent: "var(--ec-status-error-border, #ef4444)",
    border: "rgba(239, 68, 68, 0.28)",
    background: "rgba(254, 242, 242, 0.98)",
    valueColor: "var(--ec-status-error-text, #b91c1c)",
  },
};

export const getReportSummaryTone = (tone = "default") =>
  REPORT_SUMMARY_TONES[tone] || REPORT_SUMMARY_TONES.default;

export const buildReportSummaryCardSx = (tone = "default") => {
  const palette = getReportSummaryTone(tone);

  return {
    position: "relative",
    overflow: "hidden",
    p: 1.5,
    borderRadius: 2,
    border: "1px solid",
    borderColor: palette.border,
    background: palette.background,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 4,
      backgroundColor: palette.accent,
    },
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 8px 18px rgba(15, 23, 42, 0.08)",
      borderColor: palette.accent,
    },
  };
};

export const reportSummaryCardSx = buildReportSummaryCardSx();

export const reportSummaryValueSx = (tone = "default") => ({
  mt: 0.35,
  fontWeight: 700,
  color: getReportSummaryTone(tone).valueColor,
});

export const reportSummaryLabelSx = {
  color: "text.secondary",
  fontWeight: 600,
  letterSpacing: "0.04em",
};

export const reportSummaryHelperTextSx = {
  mt: 0.75,
  color: "text.secondary",
  lineHeight: 1.3,
};

export const reportSummaryHeaderSx = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1,
};

export const reportSummaryCardContentSx = {
  position: "relative",
  zIndex: 1,
};

export const reportSummaryStatusSx = {
  flexShrink: 0,
};

export const reportSummaryGridSx = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(180px, 1fr))",
    lg: "repeat(4, minmax(160px, 1fr))",
  },
  gap: 1.5,
};

export const legacyReportSummaryCardSx = {
  p: 1.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "background.paper",
};

export const reportTableSectionSx = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: { xs: 420, md: 600 },
  overflow: "hidden",
};

export const reportSecondaryShellSx = {
  ...reportShellSx,
  flex: "0 0 auto",
};

export const reportTablePaperSx = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  backgroundColor: "background.paper",
};

export const reportTableContainerSx = {
  flex: 1,
  minHeight: 0,
  overflow: "auto",
  "&::-webkit-scrollbar": { width: 6, height: 6 },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "var(--ec-color-border-strong, #cbd5e1)",
    borderRadius: 99,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
};

export const reportTableHeaderCellSx = ({
  active = false,
  sortable = false,
  minWidth = 120,
} = {}) => ({
  minWidth,
  px: 2,
  py: 1.25,
  backgroundColor: "#f8fafc !important",
  color: active
    ? "var(--ec-table-head-text-inverse, #0f172a)"
    : "var(--ec-table-head-text-muted, #475569)",
  fontWeight: 700,
  fontSize: "0.72rem",
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  borderBottom: "none",
  cursor: sortable ? "pointer" : "default",
  userSelect: "none",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  zIndex: 2,
  transition: "all 0.15s ease",
  "&:hover": sortable
    ? {
        backgroundColor: "var(--ec-table-head-bg-hover, #eef2f7) !important",
        color: "var(--ec-table-head-text-inverse, #0f172a)",
      }
    : undefined,
});

export const reportTableBodySx = {
  "& .MuiTableCell-root": {
    borderBottom: "1px solid",
    borderColor: "divider",
  },
  "& .MuiTableRow-root:last-child .MuiTableCell-root": {
    borderBottom: "none",
  },
};

export const reportTableFooterSx = {
  px: 2,
  borderTop: "1px solid",
  borderColor: "divider",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: 52,
  backgroundColor: "background.paper",
};
